module.exports = __webpack_public_path__ + "img/honor-right-2-1.181a2ac4.jpg";